import { FC, useMemo } from 'react';

import { GiftOrderSearchParams } from '@shared/api/giftOrder/giftOrder.hook';
import { phoneNumberStringFormator } from '@shared/utils/phoneNumberStringFormator';

import { OrderSearchResultsView } from './OrderSearchResultsView';

interface OrdererOrdersModalProps {
  /** 주문자 핸드폰번호 (포맷팅된 그대로 받아도 됨 — 내부에서 숫자만 추출) */
  phoneNumber: string;
  onClose: () => void;
}

export const OrdererOrdersModal: FC<OrdererOrdersModalProps> = ({
  phoneNumber,
  onClose,
}) => {
  const params: GiftOrderSearchParams = useMemo(() => {
    const digits = phoneNumber.replace(/[^0-9]/g, '');
    return { phoneNumber: digits };
  }, [phoneNumber]);

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4">
      <div className="fixed inset-0 bg-black/50" onClick={onClose} />
      <div className="relative my-4 flex max-h-[92vh] w-full max-w-[1200px] flex-col overflow-hidden rounded-xl bg-white shadow-2xl">
        {/* 헤더 */}
        <div className="flex items-center justify-between border-b border-gray-200 px-5 py-4">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              주문자 관련 주문 목록
            </h2>
            <p className="mt-0.5 text-xs text-gray-500">
              핸드폰번호 <span className="font-medium text-gray-700">
                {phoneNumberStringFormator(phoneNumber)}
              </span>{' '}
              로 검색된 결과입니다.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
            aria-label="닫기"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* 본문 - 스크롤 가능 */}
        <div className="min-h-0 flex-1 overflow-auto bg-gray-50 p-4">
          <OrderSearchResultsView searchParams={params} hasSearched />
        </div>
      </div>
    </div>
  );
};
